// Single source of truth for whether a profile's Current Thought has
// expired. The scheduled job (see the expire_thoughts migration) is what
// actually deletes the text from the database on its own cadence — this is
// only a client-side guard for the window between expiry and the next cron
// run, so the card doesn't sit stale for up to 15 minutes.
export function isThoughtExpired(profile) {
  if (!profile?.current_thought) return true; // nothing to show either way
  if (!profile?.thought_expires_at) return true; // has text but no expiry on record — cannot verify, so treat as expired
  return new Date(profile.thought_expires_at) < new Date();
}

// The live thought text, or null if there isn't one or it's expired.
export function activeThought(profile) {
  return isThoughtExpired(profile) ? null : (profile?.current_thought || null);
}